import { useEffect, useState, useContext } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import GlobalContext from "../../../context/GlobalContext";
import { userService } from "../../../services/CommonServices";
import ReactPaginate from 'react-paginate';
import * as XLSX from "xlsx";
import Loader from '../../Loader/Loader';

const DeletedCustomersList = () => {
    let navigate = useNavigate();
    const location = useLocation();
    const globalData = useContext(GlobalContext);

    const [res, setRes] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [totalPages, setTotalPages] = useState(0);

    const headers = {
        "Authorization": globalData.token,
    };

    // Fetch data with pagination and search query
    const fetchDeletedCustomers = (page, search) => {
        setIsLoading(true);
        const params = {
            page,
            size: 10,
            search,
        };

        userService.deleted_customers_list_api(headers, params)
            .then((response) => {
                if (response.status === 200) {
                    setRes(response.data.data);
                    setTotalPages(Math.ceil(response.data.total / 10));
                    setIsLoading(false);
                }
            })
            .catch((error) => {
                console.error(error);
                setIsLoading(false);
                if (error.response?.status === 401) {
                    globalData.set_token("");
                    globalData.set_org_id("");
                    sessionStorage.removeItem('token');
                    sessionStorage.removeItem('org_id');
                    navigate('/login');
                }
            });
    };

    // Handle search input
    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleSearchSubmit = (event) => {
        event.preventDefault();
        setPage(0); // Reset to the first page when searching
        fetchDeletedCustomers(0, searchQuery);
    };

    // Handle page change
    const handlePageClick = (event) => {
        const selectedPage = event.selected;
        setPage(selectedPage);
        fetchDeletedCustomers(selectedPage, searchQuery);
    };

    // Export to Excel
    const exportToExcel = () => {
        const ws = XLSX.utils.json_to_sheet(res);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Deleted Customers");
        XLSX.writeFile(wb, "deleted_customers.xlsx");
    };

    // Initial load
    useEffect(() => {
        fetchDeletedCustomers(page, searchQuery);
    }, [page, searchQuery]); // Dependency on page and searchQuery

    return (
        <div className="content_area">
            <div>
                {isLoading && <Loader />}
            </div>
            <div className="tables_area">
                <div className="title-box">
                    <h2 className="pull-left">Deleted Customers List</h2>
                    <div className="clear"></div>
                </div>
                <div className="filter-box">
                    <form onSubmit={handleSearchSubmit}>
                        <input
                            type="text"
                            value={searchQuery}
                            onChange={handleSearchChange}
                            placeholder="Search by name or phone"
                        />
                        <button type="submit">Search</button>
                    </form>
                    <button onClick={exportToExcel}>Export to Excel</button>
                </div>
                <div className="white_box">
                    <div className="table-responsive">
                        <table width="100%" cellspacing="0" cellpadding="0">
                            <thead>
                                <tr>
                                    <th>id</th>
                                    <th>Email</th>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>Country Code</th>
                                    <th>Phone Number</th>
                                    <th>Street Address</th>
                                    <th>City</th>
                                    <th>State</th>
                                    <th>Zip Code</th>
                                </tr>
                            </thead>
                            <tbody>
                                {res.map((item) => (
                                    <tr key={item.id}>
                                        <td>{item.id}</td>
                                        <td>{item.email}</td>
                                        <td>{item.firstName}</td>
                                        <td>{item.lastName}</td>
                                        <td>{item.countryCode}</td>
                                        <td>{item.phoneNumber}</td>
                                        <td>{item.streetAddress}</td>
                                        <td>{item.city}</td>
                                        <td>{item.state}</td>
                                        <td>{item.zipCode}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <ReactPaginate
                            breakLabel="..."
                            nextLabel="next >"
                            onPageChange={handlePageClick}
                            pageRangeDisplayed={5}
                            pageCount={totalPages}
                            previousLabel="< previous"
                            renderOnZeroPageCount={null}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeletedCustomersList;